const EnrollmentInstantiationType = {
  NewLegalPersonRut: 'NewLegalPersonRut',
  ExistingLegalPersonRut: 'ExistingLegalPersonRut',
  InProgress: 'InProgress',
};

export default EnrollmentInstantiationType;
